import React from 'react'

const ActionsList = () => {
  return (
    <div className='container'>
    <h1 className='text-2xl font-bold text-center text-primary'>ActionsList</h1>
</div>
  )
}

export default ActionsList